import { useTriggerAction, useUpdateWidgetValue } from '@libs/core';
import { ActionActionTypeEnum, TCommonDataObj, TWidget } from '@libs/types';
import { useCallback, useRef } from 'react';
import { KycOutcome, TKycProviderData, TKycProviderOutput } from '../../../types/data';

const OUTCOME_ACTION_NAME: Record<KycOutcome, string> = {
    [KycOutcome.SUCCESS]: 'onSuccess',
    [KycOutcome.ERROR]: 'onError',
    [KycOutcome.CANCEL]: 'onCancel',
};

export const useKycOutcome = (widget: TWidget<TKycProviderData>) => {
    const { updateWidgetValue } = useUpdateWidgetValue(widget);
    const { triggerActionsByNameAndType } = useTriggerAction(widget);
    const firedRef = useRef(false);

    const fireOutcome = useCallback(
        (value: TKycProviderOutput) => {
            if (firedRef.current) return;
            firedRef.current = true;

            updateWidgetValue(value as TCommonDataObj);
            triggerActionsByNameAndType(ActionActionTypeEnum.onFilled, OUTCOME_ACTION_NAME[value.outcome]).then();
        },
        [updateWidgetValue, triggerActionsByNameAndType],
    );

    return { fireOutcome };
};
